import React from 'react';

import './WhyBookWithUs.css';
import { getAppEnv } from '../../../config/env';
import { Usp } from '../../pages/runtime-typechecker';

type WhyBookWithUsProps = {
  usps: Usp[];
  useDirectSourceUrl?: boolean;
};

const env = getAppEnv();
const { PUBLIC_URL } = env.raw;

const WhyBookWithUs = ({
  usps,
  useDirectSourceUrl = false
}: WhyBookWithUsProps) => {
  return (
    <ul className="bookWithUsCard">
      {usps.map(usp => (
        <li className="bookWithUsItem" key={`usp_${usp.id}`}>
          <img
            className="bookWithUsIcon lazyload"
            alt={usp.uspTitle}
            data-src={
              useDirectSourceUrl
                ? usp.logoUrl
                : `${PUBLIC_URL}/static/public/${usp.logoUrl}`
            }
          ></img>
          <div className="itemDes">
            <p className="titleText blackText latoBold">{usp.uspTitle}</p>
            <p className="desText greyText">{usp.uspDescription}</p>
          </div>
        </li>
      ))}
    </ul>
  );
};

export default WhyBookWithUs;
